import type { IconType } from "react-icons";
import { FaAward, FaBell, FaBullhorn, FaClock, FaComment, FaEnvelope, FaQuestion, FaShareAlt, FaShoppingBasket, FaSignature, FaTasks, FaTimes } from "react-icons/fa";
import { NotificationTypeDto } from "../../../autogen/bff-api";

export type NotificationChipColor = "teal" | "amber" | "blue" | "green" | "red" | "violet" | "neutral";
export interface NotificationVisual { icon: IconType; colorScheme: NotificationChipColor; }

const T = NotificationTypeDto;
const MAP: Partial<Record<NotificationTypeDto, NotificationVisual>> = {
  [T.ContractDateReminder]: { icon: FaClock, colorScheme: "teal" },
  [T.ContractTaskDueDateReminder]: { icon: FaTasks, colorScheme: "amber" },
  [T.ContractTaskDelegated]: { icon: FaTasks, colorScheme: "amber" },
  [T.ContractTaskStatusUpdated]: { icon: FaTasks, colorScheme: "amber" },
  [T.ContractTaskCommentAdded]: { icon: FaComment, colorScheme: "amber" },
  [T.ContractTaskDeleted]: { icon: FaTasks, colorScheme: "amber" },
  [T.ContractTaskDueDateUpdated]: { icon: FaTasks, colorScheme: "amber" },
  [T.ContractSharedWithDepartment]: { icon: FaShareAlt, colorScheme: "blue" },
  [T.ContractSharedWithOrg]: { icon: FaShareAlt, colorScheme: "blue" },
  [T.ContractSharedWithPerson]: { icon: FaShareAlt, colorScheme: "blue" },
  [T.ContractDocumentCompletedSigning]: { icon: FaSignature, colorScheme: "green" },
  [T.ContractSignatureDeadlineExpired]: { icon: FaSignature, colorScheme: "red" },
  [T.SourcingEventAnnouncement]: { icon: FaBullhorn, colorScheme: "teal" },
  [T.SeV2InformationPublished]: { icon: FaBullhorn, colorScheme: "teal" },
  [T.SourcingEventAwarded]: { icon: FaAward, colorScheme: "violet" },
  [T.SourcingEventNewQuestion]: { icon: FaQuestion, colorScheme: "violet" },
  [T.SourcingEventQuestionStatusUpdated]: { icon: FaQuestion, colorScheme: "violet" },
  [T.SeV2NewQuestion]: { icon: FaQuestion, colorScheme: "violet" },
  [T.SeV2QuestionAnswered]: { icon: FaQuestion, colorScheme: "violet" },
  [T.SourcingEventNewQuestionComment]: { icon: FaComment, colorScheme: "violet" },
  [T.SourcingEventOrganizationInvite]: { icon: FaShoppingBasket, colorScheme: "blue" },
  [T.NegotiationInvite]: { icon: FaShoppingBasket, colorScheme: "blue" },
  [T.BidDeliveryDeadline]: { icon: FaShoppingBasket, colorScheme: "amber" },
  [T.BidDelivered]: { icon: FaEnvelope, colorScheme: "green" },
  [T.SourcingEventCancelled]: { icon: FaTimes, colorScheme: "red" },
  [T.SourcingEventClosed]: { icon: FaTimes, colorScheme: "neutral" },
};

const FALLBACK: NotificationVisual = { icon: FaBell, colorScheme: "neutral" };
export const notificationVisual = (type: NotificationTypeDto): NotificationVisual => MAP[type] ?? FALLBACK;

// Chip background/foreground per color — semantic tokens for dark-mode awareness.
export const CHIP_BG: Record<NotificationChipColor, string> = {
  teal: "smChipTealBg", amber: "smChipAmberBg", blue: "smChipBlueBg", green: "smChipGreenBg", red: "smChipRedBg", violet: "smChipVioletBg", neutral: "smBackgroundTertiary",
};
export const CHIP_FG: Record<NotificationChipColor, string> = {
  teal: "smChipTealFg", amber: "smChipAmberFg", blue: "smChipBlueFg", green: "smChipGreenFg", red: "smChipRedFg", violet: "smChipVioletFg", neutral: "smMuted",
};
